module.exports = __webpack_public_path__ + "img/GALERIA-XL7-2021-3.c6d5b0b5.jpg";